import { render, staticRenderFns } from "./TestRequestPay.vue?vue&type=template&id=24227502&scoped=true&"
import script from "./TestRequestPay.vue?vue&type=script&lang=js&"
export * from "./TestRequestPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24227502",
  null
  
)

export default component.exports